<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block" v-if="enable">
        <li class="fa fa-recycle"></li> SZCS#SLEEPT=3
    </button>
    <button @click="reset()" type="button" class="btn btn-sm btn-danger btn-block" v-else>
        <li class="fa fa-recycle"></li> SZCS#SLEEPT=0
    </button>
</template>
<script>
    import {Comandos} from '../../../../class';
    import {Bus} from '../../../../class/bus';
    export default {
        name: "TempoParaSleepOneblock",
        props: {
            id_rastreador: {
                "default": null
            },
            enable: {
                "default": false
            }
        },
        methods: {
            async reset () {
                await Comandos.tempo2Sleep(this.id_rastreador, this.enable ? 3 : 0);
                Bus.$emit('comandos');
            }
        }
    }
</script>
